<template>
    <div class="grid-item">
        <label>
            {{label}}
        </label>

        <input-group v-if="hasIcon" :icon="icon">
            <slot></slot>
        </input-group>

        <slot v-else>

        </slot>
    </div>    
</template>

<script>

import InputGroup from '../../../../../Core/Components/Inputs/InputGroup.vue';

export default {
    name: 'filter-item',
    components: {
        InputGroup
    },
    computed: {
        hasIcon() {
            return this.icon != null;
        }
    },
    props: {
        label: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: null
        }
    }
};
</script>

<style>

</style>